<template>
    <div class="code-blockly">
        <!-- <left-side v-if="!leftSideHide" :class="['left-side']"></left-side> -->
        <div class="blockly-contaienr" id="blockly-container">
            <Control-menu v-if="selectedMenue === 'program'" :class="[shit$(`h:100%; w:150px; flt:l; bgc:#333;`)]"/>
            <template v-if="workSpace">
                <button-group class="quick-edit" direction="horizontal" :funcs="quickEditConfig"></button-group>
                <button-group class="editor-tool" direction="vertical" :funcs="editorToolConfig"></button-group>
            </template>
            <!-- <extend-block class="nuwa-extend-block" ref="extendBlock"></extend-block> -->
        </div>
        <code-preview
        v-if="isMissionProject || selectedMenue === null"
        :code="genCode"
        :visible.sync="showCode" :class="[shit$(`max-width:400px;`)]"/>
        <media-manager
            v-if="showMediaManager"
            :visible="showMediaManager"
            :type="customMediaType"
            :media-index="selectMediaIndex"
            @close="closeMiediaManager"
            @confirm="updateCustomMediaBlock"
        ></media-manager>
        <add-families v-if="showAddFamilies" :visible.sync="showAddFamilies"></add-families>
        <add-youtube-dialog ref="youtubeDialog" @parentEventGetUrl="getYoutubeUrl"></add-youtube-dialog>
        <materials-online
        v-if="showMaterialsOnline"
        :type="onLineMaterialType" 
        :lock-type="true"
        @confirm="onAddMaterialFromOnline"
        @cancel="showMaterialsOnline = false"
        ></materials-online>
        <dance-projects
        v-if="danceProjectsVisible"
        :visible.sync="danceProjectsVisible"
        ></dance-projects>
        <ai-materials v-if="showAiMaterials" @close="showAiMaterials = false" @confirm="onAddMaterialFromOnline"></ai-materials>
        <joint-angle-popper v-if="jointPopperVisible" @close="closeJointPopper" ref="jointAnglePopper"></joint-angle-popper>
    </div>
</template>

<script>
import "@/code-lab/lib/nuwa_custom_colors.js"; 
import "@/code-lab/lib/nuwa_blockly_theme.js";
import fixXmlInputAndOutput from "@/code-lab/lib/nuwa_xml_input_output"; 
import customField from "@/code-lab/lib/nuwa_custom_field.js"; 
import customBlocks from "@/code-lab/lib/nuwa_custom_blocks.js"; 
import generateCustomBlocks from "@/code-lab/lib/nuwa_custom_javascipt_generator.js"; 

import AddFamilies from "@/code-lab/component/popper-add-families.vue";
import codePreview from "@/code-lab/component/popper-code-preview.vue"; 
import mediaManager from "@/code-lab/component/media-manager.vue";
import buttonGroup from "@/code-lab/component/button-group.vue";
import buttonConfig from "@/service/mapping/codelab-button-config.js";
import ControlMenu from "@/code-lab/component/layout/control-menue/control-menu.vue";
import AddYoutubeDialog from '@/code-lab/component/add-youtube-dialog.vue'
import materialsOnline from "@/code-lab/component/materials-online/materials-online.vue";
import danceProjects from "@/code-lab/component/dance-project/dance-project.vue";
import jointAnglePopper from "@/code-lab/component/joint-angle-popper.vue";
import aiMaterials from "@/code-lab/component/ai-materials/ai-materials.vue";
import "@/code-lab/lib/nuwa_custom_trashcan.js";
import mixFileRequestManage from '@/code-lab/component/file-management/mixins/mix-file-request-manage.js'
import { mapState, mapGetters } from "vuex";
const Blockly = window.Blockly;
const CONSTS = window.CONSTS;
if(process.env.VUE_APP_mode === "dev"){
  window.getWorkSpace = function(){
    let xml = Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(Blockly.getMainWorkspace()));
    console.log(xml);
  }
}
export default {
  name: "code-blockly",
  props: ["toolbox"],
  mixins: [mixFileRequestManage],
  components: {
    codePreview,
    mediaManager,
    buttonGroup,
    "Control-menu": ControlMenu,
    AddFamilies,
    AddYoutubeDialog,
    materialsOnline,
    danceProjects,
    jointAnglePopper,
    // extendBlock
    aiMaterials
  },
  data() {
    return {
      workSpace: null,
      resizeTimer: null,
      lastSavedScript: "",
      codeChangeTiemr: null,
      dblclickTimer: 0,
      currentCustomMediaBlockId: null,
      showMediaManager: false,
      showAddFamilies: false,
      customMediaType: null,
      selectMediaIndex: "",
      //使用用户自定义素材的块
      customMediaBlockTypes: [
        "other_function_camera",
        "other_function_video",
        "function_video_youtube",
        "sound_record"
      ],
      quickEditConfig: buttonConfig.quickEdit,
      editorToolConfig: buttonConfig.editorTool,
      quickStore: {},
      onLineMaterialType: "",
      showMaterialsOnline: false,
      showAiMaterials: false,
      danceProjectsVisible: false,
      jointPopperVisible: false
    };
  },
  computed: {
      ...mapState('user', [
          'teamId',
          'token'
      ]),
    ...mapState({
      projectData: "projectData",
      projectId: state => state.projectData ? state.projectData.projectId: null,
      materialsList: "materialsList",
      isSaved: "isSaved",
      showCode: "showCode",
      genCode: "genCode",
      showSimulator: "showSimulator", // handle dashboard width change
      langCode: "langCode",
      selectedMenue: "selectedMenue",
      isMissionMode: state => state.selectedMenue === "mission",
      currentVersion: "currentVersion",
      env$: "env$",
      tempFamilies: "tempFamilies",
      robotFamilies: "robotFamilies",
      isMissionProject: state => state.selectedMenue === "mission" && state.currentMission,
      connectGolbalState: "connectGolbalState"
    }),
    ...mapState("quickConnection", {
      connectDevices: "connectDevices"
    }),
    ...mapGetters("extendBlock", [
      "blocklyExtendCategory"
    ]),
    script() {
      return this.projectData.script;
    }
  },
  watch: {
    showSimulator() {
      if (this.workSpace) {
        this.$nextTick(() => {
          this.onResize(this.workSpace);
        });
      }
    },
    selectedMenue(value, oldValue) {
      if (oldValue === "mission" && value !== oldValue && this.workSpace) {
        this.$nextTick(() => {
          this.defaultBlock();
        });
      }
      if (oldValue === "program" && !value) {
        this.$nextTick(() => {
          this.onResize(this.workSpace);
        });
      }
    },
    tempFamilies(){
    	this.updateEventFieldFamilieOptions();
    },
    robotFamilies(){
    	this.updateEventFieldFamilieOptions();
    },
    // blocklyExtendCategory(value){
    //   this.$nextTick(() => {
    //     this.updateToolbox();
    //   })
    // }
  },
  created() {
    fixXmlInputAndOutput();
    customField({
      token: this.token,
      customerId: this.teamId
    });
    customBlocks();
    generateCustomBlocks();
    
    Blockly.getMaterialByIndex = this.getMaterialByIndex;
    Blockly.getNuwaMaterialsByType = this.getNuwaMaterialsByType;
    Blockly.getRoleEmotions = this.getRoleEmotions;
    Blockly.getRobotFamily = this.getRobotFamily;
    Blockly.deleteProjectMaterial = this.deleteProjectMaterial;
    Blockly.showJointAnglePopper = this.showJointAnglePopper;
    this.updateEventFieldFamilieOptions();

    // this.getExtendBlock();
  },
  mounted() {
    this.$nextTick(() => {
      this.init(this.toolbox);
      if (!this.projectData.projectId) {
        this.$store.commit("UPDATE_PROJECT_DATA", {
          name: this.$t("UNNAMEDPROJECT")
        });
      }
      window.loadToWorkspace = this.loadToWorkspace.bind(this);
      document.body.addEventListener("addfamilies", this.onAddFmilies);
      document.body.addEventListener("openMaterialLib", this.openMaterialLib);
    });
  },
  methods: {
    // ...mapActions("extendBlock", {
    //   getExtendBlock: "GET_EXTEND_BLOCK"
    // }),
    computedLeftSideHide() {
      const mapping = { public: 0, student: 0, family: 0, teacher: 0 };
      return !!mapping[this.currentVersion];
    },
    computedDashBordWidth() {
      const mapping = { public: 64, student: 64, family: 64, teacher: 64 };
      return mapping[this.currentVersion];
    },
    setInitBlockWorkSpaceAfter(spaceX) {
      spaceX.scrollbar.setContainerVisible(false); 
      this.updateIconOfToolBox();
      // this.insertEditBlockButton();
    },
    init(toolbox) {
      this.initWorkSpace(toolbox);
      this.setInitBlockWorkSpaceAfter(this.workSpace);
    },
    initWorkSpace(toolbox) {
      
      this.$root.blocklyWorkSpace = this.workSpace = Blockly.inject(
        "blockly-container",
        {
          media: `${this.env$}static/js/blockly/media/`,
          toolbox,
          theme: Blockly.Themes.Nuwa,
          zoom: {
            controls: false,
            wheel: false,
            startScale: 1,
            maxScale: 3,
            minScale: 0.3,
            scaleSpeed: 1.2
          },
          grid: {
            spacing: 10,
            length: 1,
            colour: "#0ed3ff",
            snap: true 
          }
        }
      );
      
      this.$store.commit("SET_WORK_SPACE", this.workSpace);
      this.defaultBlock();
      const code = Blockly.JavaScript.workspaceToCode(this.workSpace); 
      this.lastSavedScript = this.script || CONSTS.EMPTY_WORK_SPACE;
      this.$store.commit("UPDATE_GENCODE", code);
      this.workSpace.addChangeListener(this.onWorkspaceChange); 
      this.initRootEvent();
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    },
    initRootEvent() {
      if (this.workSpace) {
        [...this.quickEditConfig, ...this.editorToolConfig].forEach(func => {
          this.$root.$on(func.fn, () => {
            if (typeof this[func.fn] === "function") {
              this[func.fn].bind(this)();
            }
          });
        });
      }
    },
    loadToWorkspace(xml_str) {
      var xml = Blockly.Xml.textToDom(xml_str);
      Blockly.Xml.hardDomToWorkspace(xml, this.workSpace);
    },
    closeMiediaManager() {
      this.showMediaManager = false;
      this.customMediaType = null;
      this.selectMediaIndex = "";
    },
    updateCustomMediaBlock(media) {
      let { index, ext, url} = media;
      if(!ext){
        ext = url.split("?")[0];
        ext = ext.split(".").pop();
      }
      index = index + "." + ext;
      let block = this.workSpace.getBlockById(this.currentCustomMediaBlockId);
      if (block) {
        block.setFieldValue(index, "input1");
        this.workSpace.fireChangeListener(this.onWorkspaceChange);
      }
      this.closeMiediaManager();
    },
    haveOtherBlock(script) {
      const startBlockNum = script.split('type="start_start"').length - 1;
      const blocksNum = script.split("</block>").length - 1;
      return blocksNum !== startBlockNum;
    },
    getYoutubeUrl (videoId) {
      let block = this.workSpace.getBlockById(this.currentCustomMediaBlockId);
      if (block) {
        block.setFieldValue(videoId, "input1");
        this.workSpace.fireChangeListener(this.onWorkspaceChange);
      }
      this.closeMiediaManager();
    },
    onWorkspaceChange(e) {
      if (e.type === Blockly.Events.UI) {
        if (e.element === "click") {
          let block = this.workSpace.getBlockById(e.blockId);
          if (this.customMediaBlockTypes.includes(block.type)) {
            let time = new Date().getTime();
            if (time - this.dblclickTimer <= 300) {
              this.dblclickTimer = 0;
              var field = block.getField("input1");
              this.customMediaType = field.mediaType;
              this.selectMediaIndex = block.getFieldValue("input1").split(".").shift();
              this.currentCustomMediaBlockId = e.blockId;
              if (this.customMediaType === 'youtube') {
                this.$refs.youtubeDialog.open()
              } else {
                if(!this.projectId){
                 if(this.isMissionProject){
                    this.$message.info(this.$t("message.warn_forbidden_upload_material_mission"));
                    this.saveMissionAsProject(() => {
                      this.showMediaManager = true;
                    });
                  } else {
                    this.saveBlockAsNewProject(() => {
                      this.showMediaManager = true;
                    });
                  }
                } else {
                  this.showMediaManager = true;
                }
                
              }
            } else {
              this.dblclickTimer = time;
            }
          }
        }
      } else {
        if (this.codeChangeTiemr) {
          clearTimeout(this.codeChangeTiemr);
          this.codeChangeTiemr = null;
        }
        this.codeChangeTiemr = setTimeout(() => {
          let xml = Blockly.Xml.workspaceToDom(this.workSpace);
          let script = Blockly.Xml.domToText(xml);
          let code = Blockly.JavaScript.workspaceToCode(this.workSpace);
          if (script && !this.compareScript(this.lastSavedScript, script)) {
            this.$store.commit("UPDATE_PROJECT_DATA", {
              script
            });
            this.$store.commit("UPDATE_IS_ALLOW_SAVED", this.haveOtherBlock(script)); 
            this.$store.commit("UPDATE_IS_SAVED", false);
            this.$store.commit("UPDATE_GENCODE", code);
            this.lastSavedScript = script;
          } else if (!script) {
            this.$store.commit("UPDATE_PROJECT_DATA", {
              script: null
            });
            this.$store.commit("UPDATE_GENCODE", code);
            this.lastSavedScript = script;
            if (!this.isMissionMode) {
              this.defaultBlock(); 
            }
          }
        }, 100);
      }
    },
    compareScript(script1, script2){
      script1 = script1.replace(/[xy]=[\"\']\-?\d+\.?\d*?[\"\']/g, "");
      script2 = script2.replace(/[xy]=[\"\']\-?\d+\.?\d*?[\"\']/g, "");
      return script1 === script2;
    },
    onResize(workSpace) {
        Blockly.svgResize(workSpace);
        this.$nextTick(() => {
            Blockly.Field.prototype.maxDisplayLength = Blockly.Field.prototype.getMaxDisplayLength();
            // 重新加载工作空间
            let xml = Blockly.Xml.workspaceToDom(this.workSpace);
            this.workSpace.clear()
            Blockly.Xml.domToWorkspace(xml, this.workSpace)
        })
    },
    handleResize() {
      
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = null;
      }
      this.resizeTimer = setTimeout(() => {
        const fn = () => {
          this.onResize(this.workSpace);
        };
        this.nextTickStack(fn);
      }, 100);
    },
    getDom(eleTag) {
      return document.querySelector(eleTag);
    },
    defaultBlock() {
      let script = this.script || CONSTS.EMPTY_WORK_SPACE;
      this.loadToWorkspace(script);
    },
    updateIconOfToolBox() {
      const fn = () => {
        const nodeList = document.querySelector(".blocklyTreeRoot").childNodes[1].children;
        let toolbox = this.allToolbox || this.toolbox;
        toolbox = new DOMParser().parseFromString(toolbox, "text/xml");
        toolbox = toolbox.children[0];
        const categories = toolbox.children;
        Array.from(nodeList).forEach((node, index) => {
          let icon = node.querySelector(".blocklyTreeIconNone");
          if(icon){
            let color = categories[index].getAttribute("colour") || "";
            if(color){
              color = Blockly.utils.replaceMessageReferences(color);
            }
            icon.style.backgroundColor = color;
          }
          let children = node.children[1].children;
          if(children.length > 0){
            Array.from(children).forEach((child, index2) => {
              icon = child.querySelector(".blocklyTreeIconNone");
              if(icon){
                let color = categories[index].children[index2].getAttribute("colour") || "";
                if(color){
                  color = Blockly.utils.replaceMessageReferences(color);
                }
                icon.style.backgroundColor = color;
              }
            })
          }
        });
      };
      this.nextTickStack(fn);
    },
    insertEditBlockButton(){
      
      const toolbox = this.$el.querySelector(".blocklyToolboxDiv");
      const wrapper = document.createElement("div");
      wrapper.className = "wrapper";
      Array.from(toolbox.children).forEach(child => {
        wrapper.append(child);
      })
      toolbox.innerHTML = "";
      toolbox.appendChild(wrapper);
      toolbox.appendChild(this.$refs.extendBlock.$el);
    },
    nextTickStack(fns) {
      this.$nextTick(fns);
    },
    getRobotFamily () {
      let quickStore = this.b$.quick.store;
      if(quickStore){
        const { serialNumber, clientId, to } = quickStore;
        const data = {
            cmd: "get_robot_family",
            data: {
                clientId: serialNumber,
                to: to || clientId,
                from: serialNumber,
                query: {
                    limit: 10,
                    page: 1
                }
            }
        }
        this.getFamilyMessage = this.$message({
          type: "info",
          message: this.$t("message.info_get_robot_family"),
          duration: 0,
          showClose: true
        });
        this.b$.send('quick', data, () => {}, {
            eventName: 'ws.cmd.update_robot_family',
            callBack: response => {
              this.$store.commit('SET_ROBOT_FAMILIES', response.data);
              this.getFamilyMessage && this.getFamilyMessage.close();
              this.$nextTick(() => {
                this.$message.success(this.$t("message.success_get_robot_family"));
              })
            }
        });
      } else {
        this.$message.info(this.$t("message.warn_updage_robot_family"));
      }
    },
    
    undoBlocklyAction() {
      this.workSpace.undo(false);
    },
    
    redoBlocklyAction() {
      this.workSpace.undo(true);
    },
    
    cutBlocklyAction() {
      if (
        Blockly.selected &&
        Blockly.selected.isDeletable() &&
        Blockly.selected.isEditable() && 
        Blockly.selected.isMovable()
      ) {
          Blockly.Events.setGroup(true)
          Blockly.hideChaff();
          Blockly.copy_(Blockly.selected);
          Blockly.selected.dispose && Blockly.selected.dispose(true, true);
          Blockly.Events.setGroup(false)      
        }
    },
    
    copyBlocklyAction() {
      if (Blockly.selected && Blockly.selected.isEditable()) {
        Blockly.copy_(Blockly.selected);
      }
    },
    
    pasteBlocklyAction() {
      if (this.workSpace && Blockly.clipboardXml_) {
        this.workSpace.paste(Blockly.clipboardXml_);
      }
    },
    centerBlocklyAction() {
      if (this.workSpace) {
        this.workSpace.setScale(1);
        this.workSpace.scrollCenter();
      }
    },
    zoomInBlocklyAction() {
      if (this.workSpace) {
        this.workSpace.zoomCenter(1);
      }
    },
    zoomOutBlocklyAction() {
      if (this.workSpace) {
        this.workSpace.zoomCenter(-1);
      }
    },
    onAddFmilies() {
      if(this.robotFamilies && this.robotFamilies.length > 0){
        this.$message({
          message: this.$t("message.warn_add_families"),
          duration: 5000
        });
        return;
      }
      this.showAddFamilies = true;
    },
    updateEventFieldFamilieOptions(){
      let tempFamilies = this.tempFamilies;
      let robotFamilies = this.robotFamilies;
      let families;
      if(!robotFamilies || robotFamilies.length === 0){
        families = [...tempFamilies];
      } else {
        families = [...robotFamilies];
      }
      Blockly.RobotEventField.setFamilyOptions(families);
    },
    getMaterialByIndex(index){
      index = index.split(".")
      let customMedias = this.materialsList.filter(item => !item.ref) || [];
      return customMedias.find(item => {
        if(index.length === 1){
          return item && (item.index === index[0] || item.projectMaterialId === index[0]);
        } else {
          let ext = item.ext;
          if(!ext){
            ext = item.url.split("?")[0];
            ext = ext.split(".").pop();
          }
          return item && (item.index === index[0] && (ext === index[1]) || item.projectMaterialId === index[0]);
        }
      });
    },
    openMaterialLib(e){
      let materialType = e.materialType;
      if(this.projectId){
        console.log("open material lib:", materialType);
        if(materialType === "dance"){
          this.openRobotDanceProjects();
        } else if(materialType === "aiObject"){
          this.showAiMaterialList()
        } else {
          this.onLineMaterialType = materialType;
          this.showMaterialsOnline = true;
          if(materialType !== "content"){
            this.materialLibOwner = "nuwa"
          } else {
            this.materialLibOwner = this.teamId;
          }
        }
      } else {
        if(this.isMissionProject){
          this.saveMissionAsProject(() => {
            if(materialType === "dance"){
              this.openRobotDanceProjects();
            } else if(materialType === "aiObject"){
              this.showAiMaterialList()
            } else {
              this.onLineMaterialType = materialType;
              this.showMaterialsOnline = true;
            }
          });
        } else {
          this.saveBlockAsNewProject(() => {
            if(materialType === "dance"){
              this.openRobotDanceProjects();
            } else if(materialType === "aiObject"){
              this.showAiMaterialList()
            } else {
              this.onLineMaterialType = materialType;
              this.showMaterialsOnline = true;
            }
          })
        }
      }
    },
    saveBlockAsNewProject(next = () => {}){
      const prams = { 
          name: this.$t("code-lab/component/file-management/index.vue_0"), 
        }
        this.add_project$(res => {
          if (res.status && Number(res.status.code) === 0) {
            const { projectId } = res.data
            let xml = Blockly.Xml.workspaceToDom(this.workSpace);
            let script = Blockly.Xml.domToText(xml);
            this.edit_project$(res => {
              if (res.status && Number(res.status.code) === 0) {
                console.log("专案保存成功", res.data)
                this.$store.commit("UPDATE_PROJECT_DATA", {
                  projectId,
                  materials: []
                });
                this.$store.commit("UPDATE_IS_SAVED", true);
                next(res.data);
              }
            }, { projectId, script: window.nuwa.utils.base64.encode(script) })
          }
        }, prams)
    },
    saveMissionAsProject(next = () => {}){
      let unwatch = this.$watch("projectId", projectId => {
        if(projectId){
          unwatch();
          next();
        }
      })
      this.$root.$emit("updateMission");
    },
    openRobotDanceProjects(){
        this.danceProjectsVisible = true;
    },
    getNuwaMaterialsByType(type, online = true){
      let materialsList = this.materialsList.filter(item => !!item.ref === online) || [];
      return materialsList.filter(item => {
        if(["image", "video"].includes(type)){
          return item.type === "media" && this.isMaterialType(item.url, type);
        } else {
          return item.type === type;
        }
      })
    },
    onAddMaterialFromOnline(payload){
      let type = payload.type;
      let typeLabel = this.$t("material_lib.material_type_"+type);
      let ref = payload.data.map(item => item.materialId);
      if(ref.length === 0){
        return;
      }
      this.b$.send('tool', {
          cmd: 'add_proj_material',
          data: {
            projectId: this.projectId,
            ref
          }
      }, res => {
          if(res.status && res.status.code === "0"){
            res = res.data;
            if(res.projectId === this.projectId){
              let materialsList = this.materialsList;
              materialsList = [...res.materials, ...materialsList];
              this.$store.commit("UPDATE_PROJECT_DATA", {materials: materialsList});
              this.$message.success(this.$t("message.success_add_material_online", {type: typeLabel}));
            }
          } else {
            this.$message.error(this.$t("message.error_add_material_online", {type: typeLabel}));
          }
      })
    },
    onAddDanceProjects(projects){
      let quickStore = this.b$.quick.store;
      let promiseAll = [];
      if(quickStore){
        const { serialNumber, clientId, to } = quickStore;
        promiseAll = projects.map(project => {
          return new Promise((resolve, reject) => {
            this.b$.send("quick", {
              cmd: "get_dance_file",
              data: {
                clientId: serialNumber,
                to: to || clientId,
                projectId: this.projectId,
                name: project.name,
                id: project.id,
                customerId: this.teamId
              }}, res => {
                if(res.data){
                  let materialsList = this.materialsList;
                  materialsList = [res.data, ...materialsList];
                  this.$store.commit("UPDATE_PROJECT_DATA", {materials: materialsList});
                  resolve(res.data);
                } else {
                  reject();
                }
              });
          });
        })
      } else {
        this.$message.error(this.$t("message.error_add_material_online", {type: this.$t("dance_project")}));
      }
      Promise.all(promiseAll).then(() => {
        this.$message.success(this.$t("message.success_add_material_online", {type: this.$t("dance_project")}));
      }).catch(err => {
        console.error("add dance file error:", err);
        this.$message.error(this.$t("message.error_add_material_online", {type: this.$t("dance_project")}));
      })
    },
    deleteProjectMaterial({projectMaterialId, type}, next = () => {}){
      let message = ''
      if(type === 'aiObject'){
        message = this.$t("message.warn_before_delete_aiobject");
      } else {
        message = this.$t("message.warn_before_delete_media");
      }
      this.$confirm(message, this.$t("popper_title.tips"), {
        confirmButtonText: this.$t("button.ok"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
        customClass: "codelab-important-tip",
        cancelButtonClass: "codelab-button gray",
        confirmButtonClass: "codelab-button blue"
      }).then(() => {
        const { clientId } = this.b$.tool.store;
        const ver = "v1";
        let cmd, data = {
          ver,
          clientId,
          customerId: this.teamId,
          projectId: this.projectId,
          projectMaterialId: [projectMaterialId]
        };
        cmd = "del_proj_material";
        this.b$.send("tool", {
          cmd,
          data
        }, res => {
          if(res.status && res.status.code === "0"){
            let materials =  this.materialsList.slice(0).filter(item => item.projectMaterialId !== projectMaterialId);
            this.$store.commit("UPDATE_PROJECT_DATA", {
              materials
            });
            next();
          } else {
            this.$message.error("message.error_delete_media");
          }
        })
      }).catch(() => {});
    },
    getRoleEmotions(index){
      let roles = this.materialsList.filter(item => item.type === "role");
      let role = roles.find(item => item.index === index);
      if(role){
        return role.metadata.emotions;
      } else {
        return [];
      }
    },
    isMaterialType(url, type){
      let map = {
        "image": ["jpg", "jpeg", "png", "gif"],
        "video": ["mp4", "mpeg", "webm", "mov"],
        "audio": ["mp3", "wav", "ogg"],
      };
      if(!map[type]){
        return false;
      }
      url = url || "";
      url = url.split("?").shift();
      let format = url.split(".").pop();
      return map[type].includes(format);
    },
    showJointAnglePopper(field){
      this.jointPopperVisible = true
      this.$nextTick(() => {
        this.$refs.jointAnglePopper.setField(field);
      })
    },
    closeJointPopper(){
      this.jointPopperVisible = false
    },
    showAiMaterialList(){
      this.showAiMaterials = true;
    },
    updateToolbox(){
      const toolbox = this.toolbox;
      let newToolBox = toolbox.replace(/\<\/xml\>/, "");
      newToolBox = `${newToolBox}${this.blocklyExtendCategory}</xml>`;
      this.allToolbox = newToolBox;
      this.workSpace.updateToolbox(newToolBox);
      this.$nextTick(() => {
        this.updateIconOfToolBox();
      })
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    this.workSpace.removeChangeListener(this.onWorkspaceChange);
    document.body.removeEventListener("addfamilies", this.onAddFmilies);
    document.body.removeEventListener("openMaterialLib", this.openMaterialLib);
  }
};
</script>

<style lang="scss">
.blocklyHtmlInput {
  height: auto;
}
.code-blockly {
  position: relative;
  .left-side {
    width: 64px;
    height: 100%;
    background: #333333;
    float: left;
    box-shadow: inset 0 2px 3px 0 rgba(31, 31, 31, 0.5);
  }
  .blockly-contaienr {
    width: 100%;
    height: 100%;
    position: relative;
    .blocklySvg {
      background-color: $--codelab-primary-black-1 !important;
      .blocklyMainBackground {
        stroke: none !important;
      }
    }
    
    .blocklyToolboxDiv {
      // width: 120px;
      width: auto;
      background-color: $--codelab-primary-black-1 !important;
      color: white;
      overflow: hidden;
      padding-bottom: 40px;
      height: 100%;
      .wrapper{
        width: auto;
        height: 100%;
        position: relative;
        overflow: auto;
      }
      .nuwa-extend-block{
        position: absolute;
        bottom: 0;
        left: 0;
        background: #444444;
        border-top: 1px solid #272727;
        z-index: 1;
        &:hover{
          background: #272727;
        }
      }
    }
    .blocklyTreeIconNone {
      width: 0;
      height: 0;
      position: absolute;
      left: 22px;
      top: 50%;
    }
    
    .blocklyTreeIconNone::before {
      content: "";
      display: block;
      width: 18px;
      height: 18px;
      border-radius: 9px;
      background: rgba(255, 255, 255, 0.1);
      position: absolute;
      left: -9px;
      top: -9px;
      z-index: 0;
    }
    .blocklyTreeIconNone::after {
      content: "";
      display: block;
      width: 12px;
      height: 12px;
      border-radius: 6px;
      background-color: inherit;
      position: absolute;
      left: -6px;
      top: -6px;
      z-index: 1;
    }
    .blocklyTreeIconClosedLtr, .blocklyTreeIconOpen{
      position: absolute;
      width: 0;
      height: 0;
      left: 19px;
      top: 14px;
      background: none;
      &.blocklyTreeIconClosedLtr::before{
        content: "";
        display: block;
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
        border-left: 6px solid #979797;
      }
    }
    .blocklyTreeIconOpen{
      left: 17px;
      top: 16px;
      &::before{
        content: "";
        display: block;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 6px solid #979797;
      }
    }
    .blocklyTreeLabel {
      font-size: 14px;
      margin-left: 22px;
      // position:relative;
      // left:38px;
      display: block;
      padding: 10px 0px;
      word-break: break-word;
      box-shadow: inset 0 1px 0 0 rgba(31, 31, 31, 0.5);
    }
    .blocklyTreeRoot{
      div[aria-level='1']{
        &>.blocklyTreeRow{
          &>.blocklyTreeLabel{
            font-size: 12px;
            margin-left: 40px;
          }
        }
        
      }
    }
    .blocklyFlyout {
      left: 1px;
      .blocklyFlyoutBackground {
        fill: rgba(99, 99, 99, 0.66);
        fill-opacity: 1 !important;
      }
    }
    .blocklyTreeRoot {
      padding: 0px 0;
      border-bottom: 1px solid rgba(31, 31, 31, 0.5);
    }
    .blocklyTreeRow {
      white-space: normal;
      height: auto;
      line-height: normal;
      position: relative;
      border-left: none !important;
      box-shadow: inset 0 1px 0 0 $--codelab-primary-black-3;
      background-color: $--codelab-primary-black-2;
      font-size: 0;
      margin-bottom: 0px;
      &:not(.blocklyTreeSelected):hover { // blocklyTreeLabel
        background-color: $--codelab-primary-black-1;
      }
      &.blocklyTreeSelected {
        .blocklyTreeIconNone {
          opacity: 0;
        }
      }
    }
    [aria-level='1']{
      &[aria-expanded='true']{
        &>.blocklyTreeRow{
          background-color: #333333 !important;
        }
      }
      &[aria-expanded='false']{
        &>.blocklyTreeRow{
          background-color: $--codelab-primary-black-2 !important;
          &:hover{
            background-color: $--codelab-primary-black-1 !important;
          }
        }
      }
      
    }
  }
  .quick-edit {
    position: absolute;
    bottom: 40px;
    right: 96px;
    z-index: 1;
  }
  .editor-tool {
    position: absolute;
    bottom: 110px;
    right: 29px;
    z-index: 1;
  }
  .editor-transcan {
    position: absolute;
    bottom: 32px;
    right: 20px;
  }
}
.myLabelStyle > .blocklyFlyoutLabelText {
  font-style: italic;
  fill: green;
}
.style-name {
  color: red;
  background-color: #000000;
  fill: red;
  stroke: blue;
}
.blocklyScrollbarHandle {
  fill: rgba(204, 204, 204, 0.2);
}
</style>
